export const theme = {
  // Backgrounds
  bg: "#1a1410",
  bgElev: "#221a14",

  // Board
  boardLight: "#d9c7a3",
  boardDark: "#5c4632",
  boardEdge: "#2d211a",
  boardLabel: "#7a6a4f",

  // Pieces
  whiteFill: "#f4ead0",
  whiteEdge: "#b6a370",
  whiteNumber: "#1a1410",
  blackFill: "#1f1812",
  blackEdge: "#5a4a38",
  blackNumber: "#efe2c0",

  // Highlights
  selected: "#b8843a",
  legalMove: "#6c8a4a",
  captureTarget: "#a83a32",
  captureFlash: "#e63946",

  // Text
  parchment: "#efe2c0",
  inkSoft: "#4a3a2c",
  accent: "#b8843a",
  accentSoft: "#d8a763",

  // Sizing (logical units; UI scales to fit viewport)
  cellPx: 64,           // base virtual cell size
  pieceMarginPx: 8,     // margin between piece and cell edge
  numberSizePx: 24,     // base font size for piece numbers
  pyramidExtraScale: 1.0, // pyramid uses the full cell

  // Animation
  slideMs: 200,
  captureFlashMs: 360,
  captureLabelMs: 2200,
} as const;

export type Theme = typeof theme;

export const FONT_RUNE = '"Cinzel", "Pirata One", "Trajan Pro", "Times New Roman", serif';
export const FONT_DISPLAY = '"Cinzel Decorative", "Cinzel", "Trajan Pro", "Times New Roman", serif';
export const FONT_UI = '"EB Garamond", "Cormorant Garamond", "Iowan Old Style", Georgia, "Times New Roman", serif';
export const FONT_SCRIPT = '"Tangerine", "Italianno", "Pinyon Script", "Apple Chancery", cursive';
